import { useEffect, useRef } from 'react';
import { toast } from 'sonner';

// Handles PWA update prompts + offline/online status toasts (bottom of screen)
const PWAStatus = () => {
  const wasOffline = useRef(false);

  useEffect(() => {
    // Service worker update available -> bottom toast with a Refresh action
    const onUpdate = (e) => {
      const registration = e.detail;
      toast('A new version is available', {
        description: 'Refresh to get the latest InnerGlow.',
        duration: Infinity,
        action: {
          label: 'Refresh',
          onClick: () => {
            const waiting = registration && registration.waiting;
            if (waiting) {
              waiting.postMessage({ type: 'SKIP_WAITING' });
            } else {
              window.location.reload();
            }
          },
        },
      });
    };

    const onOffline = () => {
      wasOffline.current = true;
      toast("You're offline", {
        id: 'net-status',
        description: 'Your changes will sync when you reconnect.',
        duration: Infinity,
      });
    };

    const onOnline = () => {
      if (!wasOffline.current) return;
      wasOffline.current = false;
      toast.dismiss('net-status');
      toast('Back online', {
        id: 'net-status',
        description: 'Connection restored.',
        duration: 3000,
      });
    };

    window.addEventListener('sw-update-available', onUpdate);
    window.addEventListener('offline', onOffline);
    window.addEventListener('online', onOnline);

    // If the app loads while already offline
    if (typeof navigator !== 'undefined' && navigator.onLine === false) {
      onOffline();
    }

    return () => {
      window.removeEventListener('sw-update-available', onUpdate);
      window.removeEventListener('offline', onOffline);
      window.removeEventListener('online', onOnline);
    };
  }, []);

  return null;
};

export default PWAStatus;
